// extracted by mini-css-extract-plugin
export var askAiIcon = "_n6-9";
export var container = "_n6-0";
export var groupSeparator = "_n6-a";
export var highlight = "_n6-4";
export var resultIcon = "_n6-5";
export var resultItem = "_n6-7";
export var resultSubtitle = "_n6-3";
export var resultTitle = "_n6-2";
export var resultsList = "_n6-1";
export var searchGroup = "_n6-6";
export var selected = "_n6-8";